module.exports = __webpack_public_path__ + "img/app.b5318ba3.png";